// Generated by running:
// `node less-to-js.js 'stylesheets/exercise-content-package/variables.less'`
    // @baseFontFamily =        "Proxima Nova"; sans-serif;
export const baseFontFamily = "'Proxima Nova',sans-serif";
    // @boldFontFamily =        "Proxima Nova Semibold"; sans-serif;
export const boldFontFamily = "'Proxima Nova Semibold',sans-serif";
    // @green:                 #76a005;
export const green = "#76A005";
    // @kaGreen:               #71b307;
export const kaGreen = "#71B307";
    // @blue:                  #1c758a;
export const blue = "#1C758A";
    // @gray:                  #aaa;
export const gray = "#AAAAAA";
    // @red:                   #ffbaba;
export const red = "#FFBABA";
    // @questionWidth:         480px;
export const questionWidth = "480px";
    // @grayLight:             #aaa;
export const grayLight = "#AAAAAA";
    // @grayLighter:           #ddd;
export const grayLighter = "#DDDDDD";
    // @learnstormBlue:        #4898fc;
export const learnstormBlue = "#4898FC";

export const white = '#FFFFFF';
export const gray98 = '#FAFAFA';
export const gray97 = '#F6F7F7';
export const gray95 = '#F0F1F2';
export const gray90 = '#E3E5E6';
export const gray85 = '#D6D8DA';
export const gray76 = '#BABEC2';
export const gray68 = '#888D93';
export const gray41 = '#626569';
export const gray25 = '#3B3e40';
export const gray17 = '#21242c';
export const black = '#000000';

export const warning1 = '#F86700';
export const warning3 = '#C75300';

    // @pure-sm-min: 568px;
export const pureSmMin = "568px";
    // @pure-md-min: 768px;
export const pureMdMin = "768px";
    // @pure-lg-min: 1024px;
export const pureLgMin = "1024px";
    // @pure-xl-min: 1280px;
export const pureXlMin = "1280px";
    // @pure-xs-max: (@pure-sm-min - 1);
export const pureXsMax = "567px";
    // @pure-sm-max: (@pure-md-min - 1);
export const pureSmMax = "767px";
    // @pure-md-max: (@pure-lg-min - 1);
export const pureMdMax = "1023px";
    // @pure-lg-max: (@pure-xl-min - 1);
export const pureLgMax = "1279px";
    // @tableBackgroundAccent: #f9f9f9; // for striping
export const tableBackgroundAccent = "#F9F9F9";
export const gtpBlue = "#4c00ff";
export const gtpIncorrectColor = "#babec2";
export const gtpCorrectColor = "#ffbe26";
    // @satBlue:               #0084ce;
export const satBlue = "#0084CE";
    // @satSelectedBackgroundColor: #e4f3f9;
export const satSelectedBackgroundColor = "#E4F3F9";
    // @satActiveBackgroundColor: #d0edf4;
export const satActiveBackgroundColor = "#D0EDF4";
    // @satCorrectColor:       #009900;
export const satCorrectColor = "#009900";
    // @satCorrectBorderColor: #00cc00;
export const satCorrectBorderColor = "#00CC00";
    // @satCorrectBackgroundColor: #e4f7e4;
export const satCorrectBackgroundColor = "#E4F7E4";
    // @satIncorrectColor:     #990000;
export const satIncorrectColor = "#990000";
    // @satIncorrectBorderColor: #cc5252;
export const satIncorrectBorderColor = "#CC5252";
    // @satIncorrectBackgroundColor: #f2ebeb;
export const satIncorrectBackgroundColor = "#F2EBEB";
    // @zIndexScratchPad: 1;
export const zIndexScratchPad = "1";
    // @zIndexAboveScratchpad: @zIndexScratchPad + 1;
export const zIndexAboveScratchpad = "2";
    // @zIndexInteractiveComponent: @zIndexAboveScratchpad + 1;
export const zIndexInteractiveComponent = "3";
    // @zIndexCurrentlyDragging: @zIndexInteractiveComponent + 1;
export const zIndexCurrentlyDragging = "4";
    // @zIndexCalculator: @zIndexCurrentlyDragging + 1;
export const zIndexCalculator = "5";
    // @phoneMargin: 16px;
export const phoneMargin = 16;

export const negativePhoneMargin = -16;
export const hintBorderWidth = 4;

    // The 'base unit' -- our new typography and layout styles are defined in
    // terms of multiples of the 'base unit'.
export const baseUnitPx = 16;

export const interactiveSizes = {
  defaultBoxSize: 400,
  defaultBoxSizeSmall: 288,
};

export const circleSize = 24;
export const radioMarginWidth = 2;

export const warningColor = "#f86700";
export const warningColorHover = "#df5c00";
export const warningColorActive = "#c75300";

export const publishBlockingErrorColor = "#be2612";

export const radioBorderColor = gray76;
export const checkedColor = kaGreen;
